import { useState } from 'react';
import { useRosterAudit } from '../../hooks/usePipeline';
import { useEffectiveUser } from '../../auth/useAuthUser';
import { isAdmin as checkIsAdmin } from '../../auth/admins';

export function RosterAuditBanner() {
  const user = useEffectiveUser();
  const isAdmin = checkIsAdmin(user.effectiveEmail);
  const { data } = useRosterAudit(isAdmin);
  const [expanded, setExpanded] = useState(false);

  if (!isAdmin || !data || data.total_issues === 0) return null;

  const { missing_persons, incomplete_roster } = data;

  return (
    <div
      style={{
        background: '#FFF8E1',
        borderBottom: '1px solid #FFE082',
        padding: '8px 20px',
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: '#5D4037',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: 'space-between' }}>
        <span>
          <strong style={{ color: '#BF360C' }}>Roster needs attention</strong> —{' '}
          {missing_persons.length > 0 && (
            <>{missing_persons.length} new internal person{missing_persons.length === 1 ? '' : 's'}</>
          )}
          {missing_persons.length > 0 && incomplete_roster.length > 0 && ', '}
          {incomplete_roster.length > 0 && (
            <>{incomplete_roster.length} incomplete row{incomplete_roster.length === 1 ? '' : 's'}</>
          )}
        </span>
        <button
          onClick={() => setExpanded((v) => !v)}
          style={{
            background: 'transparent',
            border: '1px solid #BF360C',
            color: '#BF360C',
            padding: '2px 10px',
            borderRadius: 3,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 10,
            fontWeight: 600,
            letterSpacing: 0.6,
            textTransform: 'uppercase',
          }}
        >
          {expanded ? 'Hide' : 'Show'}
        </button>
      </div>
      {expanded && (
        <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 8 }}>
          {missing_persons.length > 0 && (
            <div>
              <div style={{ fontWeight: 600, marginBottom: 4, color: '#5D4037' }}>
                Not in roster CSV:
              </div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {missing_persons.map((p) => (
                  <li key={p.person_id}>
                    {p.name} &lt;{p.email}&gt;
                  </li>
                ))}
              </ul>
            </div>
          )}
          {incomplete_roster.length > 0 && (
            <div>
              <div style={{ fontWeight: 600, marginBottom: 4, color: '#5D4037' }}>
                Missing fields:
              </div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {incomplete_roster.map((p) => (
                  <li key={p.email}>
                    {p.name || '(no name)'} &lt;{p.email}&gt; — <em>{p.missing_fields.join(', ')}</em>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div style={{ color: '#888', fontSize: 10 }}>
            Edit <code>backend/app/seed/team_roster.csv</code> and push to deploy.
          </div>
        </div>
      )}
    </div>
  );
}
